// @ts-nocheck
export default function* rootSaga() {
  return [];
}
